import { render, staticRenderFns } from "./ProfitReportComponent.vue?vue&type=template&id=4a88cb18&scoped=true"
import script from "./ProfitReportComponent.vue?vue&type=script&lang=js"
export * from "./ProfitReportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a88cb18",
  null
  
)

export default component.exports